"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetSorter = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _sortMethods = require("./sortMethods");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function mapSortMethods(sortMethodNames) {
  return sortMethodNames.map(function (name) {
    return (0, _sortMethods.sortByProjectDefault)(name);
  });
}

var AssetSorter = /*#__PURE__*/function () {
  function AssetSorter(_ref) {
    var sortMethods = _ref.sortMethods,
        _ref$ordering = _ref.ordering,
        ordering = _ref$ordering === void 0 ? "random" : _ref$ordering;

    _classCallCheck(this, AssetSorter);

    if (!(sortMethods !== null && sortMethods !== void 0 && sortMethods.length)) {
      this.sortMethods = [(0, _sortMethods.sortByProjectDefault)(ordering)];
    } else {
      this.sortMethods = mapSortMethods(sortMethods);
    }
  }

  _createClass(AssetSorter, [{
    key: "sort",
    value: function sort(assets) {
      this.sortMethods.forEach(function (sortMethod) {
        return sortMethod(assets);
      });
    }
  }]);

  return AssetSorter;
}();

exports.AssetSorter = AssetSorter;